export default "__VITE_ASSET__6jZmwP3i__"